/** Settings section header in role permission trees. */
export function isSettingsSectionHeader(header: string | null | undefined): boolean {
  return header === 'Settings';
}

/** Display label for permission group headers. */
export function displayPermissionSectionHeader(header: string | null | undefined): string {
  return header ?? '';
}

/** Sections that render as a collapsible group (plan Step 3). */
export function isCollapsiblePermissionSection(header: string | null | undefined): boolean {
  return (
    header === 'Projections' ||
    header === 'Reports' ||
    isSettingsSectionHeader(header)
  );
}
